var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import cx from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { renderToContainer } from '../../utils/render-to-container';
import { useCssVar } from '../../utils/use-css-var';
import Mask from '../mask';
import Image from '../image';
import Space from '../space';
import AutoCenter from '../auto-center';
import { ModalActionButton } from './modal-action-button';
var classPrefix = 'pen-modal';
var defaultProps = {
  visible: false,
  actions: [],
  closeOnAction: false,
  closeOnMaskClick: false,
  destroyOnClose: true,
  getContainer: function getContainer() {
    return document.body;
  }
};
export var Modal = function Modal(p) {
  var _cx;

  var props = mergeProps(defaultProps, p);
  var animDuration = parseInt(useCssVar('--pen-animate-duration'), 10); // 动画执行完才隐藏最外层

  var _useState = useState(!props.visible),
      hidden = _useState[0],
      setHidden = _useState[1];

  useEffect(function () {
    if (props.visible) {
      setHidden(false);
    }
  }, [props.visible]);

  var afterClose = function afterClose() {
    var _a;

    setHidden(true);
    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
  };

  var className = cx(classPrefix, (_cx = {}, _cx[classPrefix + "-hidden"] = hidden, _cx));
  var ref = useRef(null);
  var node = withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Mask, {
    visible: props.visible,
    onMaskClick: props.closeOnMaskClick ? props.onClose : undefined,
    className: props.maskClassName,
    style: props.maskStyle,
    destroyOnClose: props.destroyOnClose,
    disableBodyScroll: false
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    "in": props.visible,
    timeout: animDuration,
    classNames: classPrefix + "-wrap",
    onEntered: props.afterShow,
    onExited: afterClose,
    unmountOnExit: props.destroyOnClose
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classPrefix + "-wrap"
  }, Boolean(props.image) && /*#__PURE__*/React.createElement(Image, {
    src: props.image,
    alt: "modal header image",
    width: "100%"
  }), Boolean(props.header || props.title || props.content) && /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix + "-body", props.bodyClassName),
    style: props.bodyStyle
  }, /*#__PURE__*/React.createElement(Space, {
    direction: "vertical",
    block: true
  }, Boolean(props.header) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-header"
  }, props.header)), Boolean(props.title) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-title"
  }, props.title), Boolean(props.content) && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-content"
  }, typeof props.content === 'string' ? /*#__PURE__*/React.createElement(AutoCenter, null, props.content) : props.content))), props.actions.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-footer"
  }, props.actions.map(function (row, rowIndex) {
    var actions = Array.isArray(row) ? row : [row];
    return /*#__PURE__*/React.createElement("div", {
      key: rowIndex,
      className: classPrefix + "-action-row"
    }, actions.map(function (action, index) {
      return /*#__PURE__*/React.createElement(ModalActionButton, {
        key: action.key,
        action: action,
        onAction: function onAction() {
          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _a, _b;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (props.visible) {
                      _context.next = 2;
                      break;
                    }

                    return _context.abrupt("return");

                  case 2:
                    _context.next = 4;
                    return (_a = props.onAction) === null || _a === void 0 ? void 0 : _a.call(props, action, index);

                  case 4:
                    if (props.closeOnAction) {
                      (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
                    }

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        }
      });
    }));
  }))))));
  useLockScroll(ref, props.visible);
  return renderToContainer(props.getContainer, node);
};